// extracted by mini-css-extract-plugin
export default {"heading":"pi-z","list":"qi-z"};